/**
 * Complaint reducer
 *
 * @author Mamontov Andrey, 03/2022
 */
import * as ComplaintActions from '../actions/complaint';
import { Complaint } from '../../models/reception.model';
import { dtoFormatter } from '../../shared/helpers/helper.system';
import { ComplaintAction } from '../actions/complaint';
//
export const getData = (state: ComplaintState) => state.data;
export const getSelected = (state: ComplaintState) => state.selected;
export const getDatLength = (state: ComplaintState) => state.dataLength;
export const getRegisterDataLength = (state: ComplaintState) => state.registersLength;
export const getLoading = (state: ComplaintState) => state.loading;
export const getError = (state: ComplaintState) => state.error;
export const getSelectedYear = (state: ComplaintState) => state.selectedYear;
export const getSelectedPage = (state: ComplaintState) => state.selectedPage;

export interface ComplaintState {
  data: Array<Complaint>;
  selected: Complaint;
  selectedYear: string;
  selectedPage: number;
  dataLength: number;
  registersLength: number;
  loading: boolean;
  loadingRegisters: boolean;
  error: boolean;
}

export const initialState: ComplaintState = {
  data: [],
  selected: null,
  selectedYear: new Date().getFullYear().toString(),
  dataLength: 0,
  registersLength: 0,
  selectedPage: 1,
  loading: false,
  loadingRegisters: false,
  error: false
};

export function reducer (state = initialState, action: ComplaintAction): any {
  switch (action.type) {
    case ComplaintActions.LOAD_ALL: {
      return {
        ...state,
        loading: true,
        selectedPage: 1
      };
    }
    case ComplaintActions.LOAD_SUCCESS: {
      return {
        ...state,
        data: dtoFormatter<Complaint>(action.payload as any),
        dataLength: action.payload.rowCount,
        loading: false,
      };
    }
    case ComplaintActions.LOAD_ONE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ComplaintActions.LOAD_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.payload,
        loading: false,
      };
    }
    case ComplaintActions.SET_COMPLAINT_YEAR: {
      return {
        ...state,
        selectedYear: action.payload
      };
    }
    case ComplaintActions.SET_SELECTED_PAGE: {
      return {
        ...state,
        selectedPage: action.payload
      };
    }
    default:
      return { ...state };
  }
}
